"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.geocodeResultFromFetchedPlace = void 0;
const determineZoomLevel_1 = require("./determineZoomLevel");
const latLngFromPlaceLocation = (loc) => {
    const lat = typeof loc.lat === "function"
        ? loc.lat()
        : loc.lat;
    const lng = typeof loc.lng === "function"
        ? loc.lng()
        : loc.lng;
    return { lat, lng };
};
const geocodeResultFromFetchedPlace = (place, fallbackLabel) => {
    var _a, _b, _c, _d, _e, _f;
    if (!place.location)
        return null;
    const { lat, lng } = latLngFromPlaceLocation(place.location);
    if (!Number.isFinite(lat) || !Number.isFinite(lng))
        return null;
    const types = place.types && place.types.length > 0 ? place.types : ["geocode"];
    const addressComponents = ((_a = place.addressComponents) !== null && _a !== void 0 ? _a : []).map((ac) => {
        var _a, _b, _c;
        return ({
            long_name: (_a = ac.longText) !== null && _a !== void 0 ? _a : "",
            short_name: (_b = ac.shortText) !== null && _b !== void 0 ? _b : "",
            types: (_c = ac.types) !== null && _c !== void 0 ? _c : [],
        });
    });
    const pseudoResult = {
        types,
        geometry: {
            location: new google.maps.LatLng(lat, lng),
            viewport: (_b = place.viewport) !== null && _b !== void 0 ? _b : undefined,
        },
        formatted_address: (_d = (_c = place.formattedAddress) !== null && _c !== void 0 ? _c : place.displayName) !== null && _d !== void 0 ? _d : fallbackLabel,
        address_components: addressComponents,
    };
    const { zoom, bounds } = (0, determineZoomLevel_1.determineZoomLevel)([pseudoResult]);
    const resolvedName = (_f = (_e = place.formattedAddress) !== null && _e !== void 0 ? _e : place.displayName) !== null && _f !== void 0 ? _f : fallbackLabel;
    return { lat, lng, zoom, bounds, resolvedName };
};
exports.geocodeResultFromFetchedPlace = geocodeResultFromFetchedPlace;
